import { render, staticRenderFns } from "./DedicatedList.vue?vue&type=template&id=780ea600"
import script from "./DedicatedList.vue?vue&type=script&lang=js"
export * from "./DedicatedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports